import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function PrivacyPolicy() {
  return (
    <>
      <style>{`
        html, body {
          overflow-x: hidden !important;
        }
        .privacy-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px 20px;
          line-height: 1.6;
          color: #334155;
        }
        .privacy-header {
          text-align: center;
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 2px solid #e5e7eb;
        }
        .privacy-header h1 {
          color: #2563eb;
          font-size: 2.5rem;
          font-weight: 900;
          margin-bottom: 10px;
        }
        .privacy-header p {
          color: #64748b;
          font-size: 1.1rem;
        }
        .privacy-section {
          margin-bottom: 30px;
        }
        .privacy-section h2 {
          color: #2563eb;
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 15px;
          border-left: 4px solid #2563eb;
          padding-left: 15px;
        }
        .privacy-section h3 {
          color: #475569;
          font-size: 1.2rem;
          font-weight: 600;
          margin: 20px 0 10px 0;
        }
        .privacy-section p {
          margin-bottom: 15px;
          text-align: justify;
        }
        .privacy-section ul {
          margin: 15px 0;
          padding-left: 20px;
        }
        .privacy-section li {
          margin-bottom: 8px;
        }
        .contact-info {
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 20px;
          margin: 20px 0;
        }
        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #2563eb;
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 600;
          margin-bottom: 30px;
          transition: background-color 0.2s;
        }
        .back-button:hover {
          background: #1d4ed8;
        }
        @media (max-width: 768px) {
          .privacy-container {
            padding: 20px 15px;
          }
          .privacy-header h1 {
            font-size: 2rem;
          }
          .privacy-section h2 {
            font-size: 1.3rem;
          }
        }
      `}</style>
      
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(90deg, #f1f5fe 0%, #fff 100%)',
        padding: '20px 0'
      }}>
        <div className="privacy-container">
          <a href="/" className="back-button">
            <i className="fas fa-arrow-left"></i>
            Nazad na početnu
          </a>
          
          <div className="privacy-header">
            <h1>Politika Privatnosti</h1>
            <p>CSV/Excel Konverter Pro</p>
            <p>Poslednje ažuriranje: {new Date().toLocaleDateString('sr-RS')}</p>
          </div>

          <div className="privacy-section">
            <h2>1. Uvod</h2>
            <p>
              CSV/Excel Konverter Pro ("mi", "naš", "usluga") poštuje vašu privatnost i obavezuje se da štiti vaše lične podatke. 
              Ova Politika privatnosti objašnjava kako prikupljamo, koristimo, čuvamo i štitimo vaše informacije kada koristite našu uslugu.
            </p>
          </div>

          <div className="privacy-section">
            <h2>2. Podaci koje prikupljamo</h2>
            
            <h3>2.1 Podaci koje nam direktno pružate:</h3>
            <ul>
              <li>Ime i prezime</li>
              <li>Email adresa</li>
              <li>Naziv kompanije</li>
              <li>Kontakt informacije</li>
              <li>Podaci o računu i plaćanju</li>
            </ul>

            <h3>2.2 Podaci koje automatski prikupljamo:</h3>
            <ul>
              <li>IP adresa i lokacija</li>
              <li>Informacije o uređaju i pretraživaču</li>
              <li>Podaci o korišćenju aplikacije</li>
              <li>Cookies i slične tehnologije</li>
            </ul>

            <h3>2.3 Podaci o fajlovima:</h3>
            <p>
              Kada otpremate CSV ili Excel fajlove za konverziju, ovi fajlovi se privremeno čuvaju na našim serverima 
              samo u svrhu obrade. Fajlovi se automatski brišu nakon završetka konverzije ili nakon 24 sata.
            </p>
          </div>

          <div className="privacy-section">
            <h2>3. Kako koristimo vaše podatke</h2>
            <p>Vaše podatke koristimo za:</p>
            <ul>
              <li>Pružanje i održavanje naše usluge konverzije</li>
              <li>Kreiranje i upravljanje vašim nalogom</li>
              <li>Komunikaciju sa vama o vašem nalogu i usluzi</li>
              <li>Poboljšanje naših usluga i korisničkog iskustva</li>
              <li>Pružanje korisničke podrške</li>
              <li>Procesiranje plaćanja</li>
              <li>Ispunjavanje zakonskih obaveza</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>4. Deljenje podataka</h2>
            <p>
              Ne prodajemo, ne iznajmljujemo niti ne delimo vaše lične podatke sa trećim stranama, 
              osim u sledećim slučajevima:
            </p>
            <ul>
              <li>Sa vašim izričitim pristankom</li>
              <li>Kada je to potrebno za pružanje usluge (npr. procesor plaćanja)</li>
              <li>Kada to zahteva zakon ili sudski nalog</li>
              <li>Za zaštitu naših prava, bezbednosti ili bezbednosti drugih</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>5. Sigurnost podataka</h2>
            <p>
              Implementirali smo odgovarajuće tehničke i organizacione mere zaštite vaših ličnih podataka, uključujući:
            </p>
            <ul>
              <li>Enkripciju podataka u prenosu i mirovanju</li>
              <li>Redovne sigurnosne provere</li>
              <li>Ograničen pristup podacima samo ovlašćenim osoblju</li>
              <li>Redovne backup strategije</li>
              <li>Monitoring i detekciju bezbednosnih incidenata</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>6. Vaša prava</h2>
            <p>Imate pravo da:</p>
            <ul>
              <li>Pristupite svojim ličnim podacima</li>
              <li>Ispravite netačne podatke</li>
              <li>Zatražite brisanje vaših podataka</li>
              <li>Ograničite obradu vaših podataka</li>
              <li>Prenesete svoje podatke</li>
              <li>Povučete pristanak</li>
              <li>Podnesete pritužbu nadležnom organu</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>7. Cookies i slične tehnologije</h2>
            <p>
              Koristimo cookies i slične tehnologije za poboljšanje funkcionalnosti našeg sajta, 
              analizu korišćenja i personalizaciju sadržaja. Možete kontrolisati korišćenje cookies-a 
              kroz podešavanja vašeg pretraživača.
            </p>
          </div>

          <div className="privacy-section">
            <h2>8. Čuvanje podataka</h2>
            <p>
              Vaše lične podatke čuvamo samo onoliko dugo koliko je potrebno za ispunjavanje svrha 
              za koje su prikupljeni ili koliko zahteva zakon. Fajlovi koji se otpremaju za konverziju 
              se automatski brišu nakon 24 sata.
            </p>
          </div>

          <div className="privacy-section">
            <h2>9. Međunarodni transfer podataka</h2>
            <p>
              Vaši podaci se mogu obrađivati i čuvati u zemljama izvan vaše zemlje prebivališta. 
              Uvek osiguravamo da se takvi transferi vrše u skladu sa odgovarajućim zaštitnim merama.
            </p>
          </div>

          <div className="privacy-section">
            <h2>10. Promene politike privatnosti</h2>
            <p>
              Možemo povremeno ažurirati ovu Politiku privatnosti. O svim značajnim promenama 
              obavestićemo vas putem email-a ili kroz našu aplikaciju. Preporučujemo da redovno 
              proveravate ovu stranicu.
            </p>
          </div>

          <div className="privacy-section">
            <h2>11. Kontakt</h2>
            <div className="contact-info">
              <p><strong>Za sva pitanja o ovoj Politici privatnosti:</strong></p>
              <p>Email: <a href="mailto:nemanja@lizzardsolutions.com" style={{color: '#2563eb'}}>nemanja@lizzardsolutions.com</a></p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>12. Sef zaštite podataka</h2>
            <p>
              Imamo imenovanog Sefa zaštite podataka koji je zadužen za sprovođenje ove Politike privatnosti 
              i može biti kontaktiran na: <a href="mailto:nemanja@lizzardsolutions.com" style={{color: '#2563eb'}}>nemanja@lizzardsolutions.com</a>
            </p>
          </div>

          <div style={{
            marginTop: 40,
            padding: 20,
            background: '#f8fafc',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            textAlign: 'center',
            color: '#64748b'
          }}>
            <p>&copy; {new Date().getFullYear()} CSV/Excel Konverter Pro. Sva prava zadržana.</p>
          </div>
        </div>
      </div>
    </>
  );
} 